export const replyTicketTemplate = (
	ticketId: string,
	numberTicket: string,
	userName: string,
	answerText: string,
	action?: string
) => {
	return `
    <h2><strong>Sua solicitação foi atualizada</strong><br /></h2>
   <p style="font-weight: bold; font-size: 12px"> Número do seu ticket: #${numberTicket}</p><br />

   ${
			!action
				? `
    Para acompanhar o andamento ou responder a este chamado, acesse o link da central Inbox:<br /><br />`
				: ''
		}

👉 <a href="https://inbox.taugor.app/tickets/${ticketId}" target="_blank">Acesse seu ticket</a><br /><br />

    <div style="border: 1px solid #000; padding: 15px;">
    <div style="line-height: 0">
    <h3><strong>${userName}</strong></h3>
    <p style="font-size: 12px; color: #999">${new Date().toLocaleString()}</p>
    </div>
    <p>${answerText}</p>
    </div>
    `;
};
